import type { MessageToast } from '~/modules/campaign/types';

export const CAMPAIGN_GROUP_MSG: Record<string, MessageToast> = {
  CREATE: {
    SUCCESS: 'Experiment created',
    FAILED: 'Experiment create failed',
  },
  WINNER: {
    SUCCESS: 'Choose winner successfully',
    FAILED: 'Choose winner failed',
  },
  UPDATE: {
    SUCCESS: 'Changes saved',
    FAILED: 'Experiment update failed',
  },
  DELETE: {
    SUCCESS: 'Experiment deleted',
    FAILED: 'Experiment delete failed',
  },
  AUTO_SAVE: {
    SUCCESS: 'Autosave success',
    FAILED: 'Autosave failed',
  },
  RUNNING: {
    SUCCESS: 'Experiment started',
    FAILED: 'Experiment start failed',
  },
  PAUSED: {
    SUCCESS: 'Experiment paused',
    FAILED: 'Experiment pause failed',
  },
  ENDED: {
    SUCCESS: 'Experiment ended',
    FAILED: 'Experiment end failed',
  },
};
